import {getToken, setToken, removeToken} from "./token";
import tools from '@/utils/tools';
import promise from 'es6-promise'
import Axios from "axios"
import qs from 'qs'
import store from './store'  //使用vuex状态管理
import router from '../router'     //路由
import{getQueryValue} from "@/utils"
import { Encrypt } from './aes'

let specWxtoken = getQueryValue("specWxtoken");
if( specWxtoken ) {
  setToken(specWxtoken);
}


promise.polyfill();
const server = Axios.create({
  baseURL: process.env.BASE_API,
  timeout: 10000
});
server.interceptors.request.use(config => {
  let token = getToken();
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  // console.log(config);
  if(config['Content-Type']) {
    config.headers['Content-Type'] = config.headers['Content-Type']
    if(config.encryption===1) {
      let data = config.data   
      config.data = { data: Encrypt(JSON.stringify(data)) }
    } else {
      config.data = config.data;
    }
  } else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = qs.stringify(config.data);
  }
  config.headers['operationSystem'] = 'h5';
  return config
}, error => {
  console.log(error);
  
});
server.interceptors.response.use(
  res => {
    if (!res || !res.data) return {};
    if ([1091005, 1091006].indexOf(res.data.errorCode) > -1) {
      removeToken();
      store.commit("SET_LOG_IN_STATIC", false);
      res.data = {
        errorCode: -999,
        errorStr: "登录信息失效,请重新登录",
        results: {}
      };
      if (window.location.hash.indexOf("login") === -1) {
        window.sessionStorage.setItem(
          "jumpUrl",
          window.location.hash.replace("#", "")
        );
      }
      // this.$router.replace("/login");
      setTimeout(function() {
        if (store.state.isJump) {
          router.replace("/account");
        }
      }, 1500);
    } else {
      if (res.data.token && res.data.token !== getToken()) {
        setToken(res.data.token);
        store.commit("SET_LOG_IN_STATIC", true);
      }
      // 非登录报错，上报sentry；
      // if (res.data.errorCode){
      //   try {
      //     Raven.captureException(
      //       {
      //         Authorization: res.config.headers.Authorization,
      //         // headers: res.config.headers,
      //         url: res.config.url,
      //         method: res.config.method,
      //         reqdata: res.config.data,
      //         resdata: res.data
      //       },
      //       {
      //         level: "error",
      //         logger: res.data && res.data.errorStr ? res.data.errorStr : "http exception"
      //       }
      //     );
      //   } catch (error) {
      //     console.log(error);
      //   }
      // }
    }
    return res.data || {};
    //设置vuex状态
  },
  error => {
    console.log(error);
    
    tools.showToast("网络异常！<br/>请检查系统版本或网络环境", 2100);
    // try {
    //   Raven.captureException(error, {
    //     level: "warning",
    //     logger: "httpError exception"
    //   });
    // } catch (error) {
    //   console.log(error);
    // }
    return Promise.reject({});
  }
);

export default server
